import React, { Component } from 'react';

import { Grid, Typography, TextField, Button, Link, Paper } from '@material-ui/core';

import { withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import { WithStyles, createStyles } from '@material-ui/core';
import VisibilityIcon from '@material-ui/icons/Visibility';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';
import { MyPATLocalLoader,MyPATTextField } from '../../common';

// import { ResetPasswordRequest, ResetPasswordError } from '../types/ForgotPassword';

const styles = (theme: Theme) => createStyles({
  paper: {
    width: '100%',
    height: '100vh',
    overflow: 'auto',
    textAlign: 'center',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    "& img": {
      margin: "0 auto",
    }
  },
  logo: {
    // paddingTop: theme.spacing.unit * 6,
  },
  loginBox: {
    textAlign: 'left',
    maxWidth: '420px',
    margin: '0 auto !important',
    paddingBottom: theme.spacing.unit * 4,
    '& > *': {
      width: '100%'
    },
    '& .passContainer': {
      position: 'relative',
      '&>div:nth-of-type(1)':{
        width: '100%',
      },
      '& .passIcon': {
        position: 'absolute',
        right: 0,
        top: 29,
        paddingRight: 0,
    },
    '& input': {
      height: 35,
    },
    '& label':{
      top: 'initial',
    }
    },
  },
  loginButton: {
    background: '#1d7dea',
    color: theme.palette.common.white,
    padding: `${theme.spacing.unit}px ${theme.spacing.unit * 2}px`,
    borderRadius: `${theme.spacing.unit * 7}px`,
    marginTop: `${theme.spacing.unit}px`,
    maxWidth: 120,
    width: '100%',
    float: 'left',
    '&:hover':{
      backgroundColor:'#1d7dea!important',
    },
  },
  forgotLink: {
    float: 'right',
    color: '#1d7dea',
    marginTop: `${theme.spacing.unit + 4}px`
  },
  clearfix: {
    display: 'table',
    clear: 'both'
  },
  title1:{
    fontSize: 22,
  },
  subtitle1:{
    fontSize: 14,
    color: '#999',
    lineHeight: '18px',
  },
  logoCont:{
    margin: '0 auto !important',
    maxWidth: 420,
    textAlign: 'left',
    paddingBottom: 32,
    width: '100%',
  },
  formContainer: {
    maxWidth: '400px',
    width: '100%',
    margin: '0 150px 0',
  }
});


export interface ResetPasswordState {
  form: any,
  formError: any,
  isFormSubmitted: boolean,
  isHidden: Boolean,
  isConfirmHidden:Boolean;
}

//@ts-ignore
export interface ResetPasswordProps extends WithStyles<typeof styles> {
  classes: any,
  loginSuccess: Function,
  resetPassword: Function,
}

class ResetPassword extends Component<ResetPasswordProps, ResetPasswordState> {

  constructor(props: ResetPasswordProps, state: ResetPasswordState) {
    super(props)

    this.state = {
      form: {
        newPassword: "",
        confirmPassword: ""
      },
      formError: {
        newPassword: "",
        confirmPassword: ""
      },

      isFormSubmitted: false,
      isHidden: true,
      isConfirmHidden:true
    };
    this.showHide = this.showHide.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);

  }

  handleChange(e: any) {
    const { name, value } = e.target;
    let form: any = this.state.form;
    form[name] = value;
   const {formError } = this.state;
   formError.confirmPassword=""
   formError.newPassword=""
    this.setState({ form: form,
      formError });
  }

  showHide(conf:any) {
    if(conf ==="conf"){
      this.setState({
        isConfirmHidden: !this.state.isConfirmHidden })
    }else{
      this.setState({ isHidden: !this.state.isHidden })
    }
   
  }


  handleSubmit(e: any) {
    e.preventDefault();
    this.setState({ isFormSubmitted: true });
    let { form, formError } = this.state;
     if (!form.newPassword) {
      formError.newPassword = "Password is Required";
      this.setState({ formError })
      return;
    }
    if (!form.confirmPassword) {
      formError.confirmPassword = "Password is Required";
      this.setState({ formError })
      return;
    }
  
    if (form.newPassword.length <6 ) {
      formError.newPassword ="Password should have atleast six charaters"
      this.setState({ formError })
      return;
    }

   
    if (form.newPassword.charAt(0)=== " " || form.newPassword.charAt(form.newPassword.length -1) === " ") {

      formError.newPassword ="Password should not have space in first and last place"
      this.setState({ formError })
      return;
    }
    if (form.newPassword != form.confirmPassword) {
      formError.confirmPassword = "Password should be match";
      this.setState({ formError })
      return;
    }
    else {
      formError.confirmPassword = "";
      this.setState({ formError })
    }
    this.props.resetPassword(form.newPassword);  
    <MyPATLocalLoader/>           
  }

  
  render() {
    const { classes } = this.props;
    const { form, formError } = this.state;

    return (
      <Paper className={classes.paper} >
        <form className={classes.formContainer} onSubmit={this.handleSubmit}>
          <Grid container direction="column">
          <Grid item className={classes.logoCont}>
            <img src="/assets/svg/authors-new-logo.svg" className={classes.logo}></img>
            </Grid>
            <Grid item>
              <div className={classes.loginBox}>
                <Typography className={classes.title1} variant="h5"><strong>Reset Password.</strong></Typography>
                <Typography className={classes.subtitle1} variant="subtitle1">Reset your password by filling the fields below.</Typography><br />
                <Grid className="passContainer">
                <MyPATTextField
                  // style={{ width: "155%" }}
                  id="outlined-password-input"
                  label="New Password"
                  name="newPassword"
                  autoComplete="current-password"
                  variant="outlined"
                  error={formError.newPassword != ""}
                  errorText={formError.newPassword}
                  onChange={this.handleChange}
                  type={this.state.isHidden ? "password" : "text"}
                />
                  <Button type="button"
                    variant="text" onClick={()=>this.showHide("curr")} className="passIcon">
                    {this.state.isHidden ? <VisibilityIcon /> : <VisibilityOffIcon />}
                  </Button>
                </Grid>
                <Typography className={classes.subtitle1} variant="subtitle1">Password must be 6 characters long alphanumeric 

                </Typography>
                <br />

                <Grid className="passContainer">
                <MyPATTextField
                  // style={{ width: "155%" }}
                  id="outlined-password-input"
                  label="Confirm Password"
                  name="confirmPassword"
                  autoComplete="current-password"
                  variant="outlined"
                  error={formError.confirmPassword != ""}
                  errorText={formError.confirmPassword}
                  onChange={this.handleChange}
                  type={this.state.isConfirmHidden ? "password" : "text"}

                />
                   <Button type="button"
                    variant="text" onClick={()=>this.showHide("conf")} className="passIcon">
                    {this.state.isConfirmHidden ? <VisibilityIcon /> : <VisibilityOffIcon />}
                  </Button>
                </Grid>

                <div>
                  <Button type="submit"
                    className={classes.loginButton}
                    variant="text">
                    Reset
                    </Button>

                  <div className={classes.clearfix}></div>
                </div>
              </div>
            </Grid>
          </Grid>
        </form>
      </Paper>
    );
  }
}

//@ts-ignore
export default withStyles(styles)(ResetPassword);